import type { ShortCircuitEvaluationRuleName } from '../..';
import type { ShortCircuitProperty } from '../../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import { KiloAmperes } from '../../../../domain/ElectricCurrent';
import type { AttentionStatusType } from '../../../AttentionStatus';
import type { ForStoringAttentionStatus2 } from '../../../AttentionStatusRepository';
import type { ForRuleProviding } from '../../../RulesProvider';
import type { ForFaultsEvaluation } from '../../ForFaultsEvaluation';
import { singleFaultEvaluation } from '../../singleElement/singleFaultEvaluation';
import type { ForShortCircuitEvaluation } from '../ForShortCircuitEvaluation';

export class FaultCurrentEvaluationEngine implements ForFaultsEvaluation {
  constructor(
    private readonly attentionStatusStorage: ForStoringAttentionStatus2,
    private readonly rulesProvider: ForRuleProviding
  ) {}

  evaluate1PhaseToGroundMax: ForShortCircuitEvaluation =
    shortCircuitProperty => {
      const ruleName: ShortCircuitEvaluationRuleName = 'Mv_Phase1Max';
      return this.evaluateFault(ruleName, shortCircuitProperty);
    };

  evaluate1PhaseToGroundMin: ForShortCircuitEvaluation =
    shortCircuitProperty => {
      const ruleName: ShortCircuitEvaluationRuleName = 'Mv_Phase1Min';
      return this.evaluateFault(ruleName, shortCircuitProperty);
    };

  evaluate2PhasesMin: ForShortCircuitEvaluation = shortCircuitProperty => {
    const ruleName: ShortCircuitEvaluationRuleName = 'Mv_Phase2Min';
    return this.evaluateFault(ruleName, shortCircuitProperty);
  };

  evaluate3PhasesMax: ForShortCircuitEvaluation = shortCircuitProperty => {
    const ruleName: ShortCircuitEvaluationRuleName = 'Mv_Phase3Max';
    return this.evaluateFault(ruleName, shortCircuitProperty);
  };

  private evaluateFault(
    ruleName: ShortCircuitEvaluationRuleName,
    shortCircuitProperty: ShortCircuitProperty
  ) {
    const evaluationRule = this.rulesProvider.getRule(ruleName);
    const evaluation = singleFaultEvaluation(
      evaluationRule,
      KiloAmperes.fromCurrent(shortCircuitProperty.faultCurrent),
      ruleName,
      this.handleEvaluationEvent(shortCircuitProperty)
    );
    return evaluation;
  }

  private handleEvaluationEvent =
    (shortCircuitProperty: ShortCircuitProperty) =>
    (attentionStatus: AttentionStatusType) =>
      this.attentionStatusStorage.apply(
        shortCircuitProperty.gridElementId,
        shortCircuitProperty.name,
        attentionStatus
      );
}
